class PincodeDetector {
	constructor() {
		this.detectors = Array.from(
			document.querySelectorAll("[data-pincode-detector]"),
		);
		this.pincodeElements = Array.from(
			document.querySelectorAll("[data-pincode-value]"),
		);
		this.storageKey = "userPincode";
		this.storageExpiryKey = "userPincodeExpiry";
		this.cacheExpiry = 24 * 60 * 60 * 1000;
		this.delhiPincodes = [
			"110001",
			"110002",
			"110003",
			"110004",
			"110005",
			"110006",
			"110007",
			"110008",
			"110009",
			"110010",
			"110011",
			"110012",
			"110013",
			"110014",
			"110015",
			"110016",
			"110017",
			"110018",
			"110019",
			"110020",
			"110021",
			"110022",
			"110023",
			"110024",
			"110025",
			"110026",
			"110027",
			"110028",
			"110029",
			"110030",
			"110031",
			"110032",
			"110033",
			"110034",
			"110035",
			"110036",
			"110037",
			"110038",
			"110039",
			"110040",
			"110041",
			"110042",
			"110043",
			"110044",
			"110045",
			"110046",
			"110047",
			"110048",
			"110049",
			"110051",
			"110052",
			"110053",
			"110054",
			"110055",
			"110056",
			"110057",
			"110058",
			"110059",
			"110060",
			"110061",
			"110062",
			"110063",
			"110064",
			"110065",
			"110066",
			"110067",
			"110068",
			"110070",
			"110071",
			"110072",
			"110073",
			"110074",
			"110075",
			"110076",
			"110077",
			"110078",
			"110081",
			"110082",
			"110083",
			"110084",
			"110085",
			"110086",
			"110087",
			"110088",
			"110089",
			"110091",
			"110092",
			"110093",
			"110094",
			"110095",
			"110096",
			"110097",
			"121001",
			"121002",
			"121003",
			"121004",
			"121005",
			"121006",
			"121007",
			"121008",
			"121009",
			"121012",
			"121013",
			"121101",
			"121102",
			"121103",
			"121106",
			"121107",
			"122001",
			"122002",
			"122003",
			"122004",
			"122005",
			"122006",
			"122008",
			"122009",
			"122010",
			"122011",
			"122015",
			"122016",
			"122017",
			"122018",
			"122022",
			"122051",
			"122052",
			"122101",
			"122102",
			"122103",
			"122105",
			"122107",
			"122108",
			"122413",
			"122502",
			"122503",
			"122504",
			"122505",
			"122506",
			"122508",
			"123001",
			"123021",
			"123101",
			"123106",
			"123110",
			"123401",
			"123501",
			"124001",
			"124102",
			"124103",
			"124104",
			"124108",
			"124109",
			"124401",
			"124501",
			"124507",
			"126101",
			"126102",
			"126113",
			"127021",
			"127306",
			"127308",
			"131001",
			"131021",
			"131023",
			"131024",
			"131027",
			"131028",
			"131039",
			"131101",
			"131103",
			"131301",
			"131302",
			"131304",
			"131306",
			"131402",
			"132001",
			"132101",
			"132102",
			"132103",
			"132104",
			"132105",
			"132107",
			"132108",
			"132113",
			"201001",
			"201002",
			"201003",
			"201004",
			"201005",
			"201006",
			"201007",
			"201008",
			"201009",
			"201010",
			"201011",
			"201012",
			"201013",
			"201014",
			"201015",
			"201016",
			"201017",
			"201102",
			"201201",
			"201204",
			"201206",
			"201301",
			"201303",
			"201304",
			"201305",
			"201306",
			"201307",
			"201308",
			"201309",
			"201310",
			"201312",
			"201313",
			"201314",
			"201315",
			"201318",
			"203001",
			"203002",
			"203129",
			"203131",
			"203135",
			"203150",
			"203201",
			"203202",
			"203203",
			"203205",
			"203207",
			"203401",
			"203403",
			"203408",
			"245101",
			"245201",
			"245205",
			"245301",
			"245304",
			"247774",
			"250001",
			"250002",
			"250003",
			"250004",
			"250005",
			"250103",
			"250110",
			"250221",
			"250341",
			"250401",
			"250501",
			"250601",
			"250606",
			"250609",
			"250611",
			"250622",
			"251001",
			"251002",
		];

		this.init();
	}

	init() {
		if (!this.detectors.length || !this.pincodeElements.length) {
			return;
		}

		const cachedPincode = this.getCachedPincode();
		if (cachedPincode) {
			this.displayPincode(cachedPincode);
			this.broadcastPincodeState(cachedPincode, "success");
		} else {
			this.displayPincode("110014");
			this.broadcastPincodeState("110014", "success");
			this.requestLocation();
		}

		this.detectors.forEach((detector) => {
			detector.addEventListener("click", () => {
				if (detector.classList.contains("navbar__pincode-detector--desktop")) {
					this.openModal();
				} else {
					this.requestLocation();
				}
			});
		});

		// Wire up "Change Pincode" button(s)
		document.querySelectorAll("[data-pincode-change]").forEach((btn) => {
			btn.addEventListener("click", () => this.openModal());
		});

		// Wire up modal
		const modal = document.getElementById("kk-pincode-modal");
		if (modal) {
			modal
				.querySelector("[data-pincode-modal-close]")
				?.addEventListener("click", () => this.closeModal());
			modal
				.querySelector("[data-pincode-modal-cancel]")
				?.addEventListener("click", () => this.closeModal());
			modal
				.querySelector("[data-pincode-modal-overlay]")
				?.addEventListener("click", () => this.closeModal());
			modal
				.querySelector("[data-pincode-modal-submit]")
				?.addEventListener("click", () => this.submitModal());

			modal
				.querySelector("#kk-pincode-input")
				?.addEventListener("keydown", (e) => {
					if (e.key === "Enter") this.submitModal();
					if (e.key === "Escape") this.closeModal();
				});

			// Handle repositioning on window resize
			window.addEventListener("resize", () => {
				this.repositionModal();
			});

			// Close modal when clicking outside on desktop (where overlay is hidden)
			document.addEventListener("click", (e) => {
				if (modal.hasAttribute("hidden")) return;
				if (window.innerWidth > 768) {
					const modalBox = modal.querySelector(".kk-pincode-modal-box");
					const desktopDetector = document.querySelector(
						".navbar__pincode-detector--desktop",
					);
					if (
						modalBox &&
						!modalBox.contains(e.target) &&
						desktopDetector &&
						!desktopDetector.contains(e.target)
					) {
						this.closeModal();
					}
				}
			});
		}
	}

	openModal() {
		const modal = document.getElementById("kk-pincode-modal");
		if (!modal) return;
		const input = modal.querySelector("#kk-pincode-input");
		const error = modal.querySelector("#kk-pincode-error");
		if (input) input.value = "";
		if (error) error.style.display = "none";
		modal.removeAttribute("hidden");
		modal.setAttribute("aria-hidden", "false");

		this.repositionModal();

		input?.focus();
	}

	repositionModal() {
		const modal = document.getElementById("kk-pincode-modal");
		if (!modal || modal.hasAttribute("hidden")) return;

		const isDesktop = window.innerWidth > 768;
		const activeDetector = document.querySelector(
			isDesktop
				? ".navbar__pincode-detector--desktop"
				: ".navbar__pincode-detector--mobile",
		);
		const modalBox = modal.querySelector(".kk-pincode-modal-box");
		const overlay = modal.querySelector("[data-pincode-modal-overlay]");

		if (overlay) {
			if (isDesktop) {
				overlay.style.display = "none";
			} else {
				overlay.style.display = "block";
			}
		}

		if (activeDetector && modalBox) {
			const rect = activeDetector.getBoundingClientRect();
			modalBox.style.top = `${rect.bottom + 8}px`;

			const modalWidth = modalBox.offsetWidth || 320;
			let left = rect.left;

			if (isDesktop) {
				left = rect.right - modalWidth;
			} else {
				left = rect.left + (rect.width - modalWidth) / 2;
			}

			// Ensure it stays within viewport boundaries
			if (left + modalWidth > window.innerWidth) {
				left = window.innerWidth - modalWidth - 16;
			}
			if (left < 16) {
				left = 16;
			}
			modalBox.style.left = `${left}px`;
		}
	}

	closeModal() {
		const modal = document.getElementById("kk-pincode-modal");
		if (!modal) return;
		modal.setAttribute("hidden", "");
		modal.setAttribute("aria-hidden", "true");
	}

	submitModal() {
		const modal = document.getElementById("kk-pincode-modal");
		const input = modal?.querySelector("#kk-pincode-input");
		const error = modal?.querySelector("#kk-pincode-error");
		const pincode = this.normalizePincode(input?.value);

		if (!pincode) {
			if (error) {
				error.textContent = "Please enter a valid 6-digit pincode.";
				error.style.display = "block";
			}
			return;
		}

		this.cachePincode(pincode);
		this.displayPincode(pincode);
		this.closeModal();
	}

	requestLocation() {
		if (!navigator.geolocation) {
			this.showError("Geolocation not supported");
			return;
		}

		this.setLoading(true);

		navigator.geolocation.getCurrentPosition(
			(position) => {
				this.handleLocationSuccess(position);
			},
			(error) => {
				this.handleLocationError(error);
			},
			{
				enableHighAccuracy: true,
				timeout: 10000,
				maximumAge: 0,
			},
		);
	}

	handleLocationSuccess(position) {
		const { latitude, longitude } = position.coords;
		this.getPincodeFromCoordinates(latitude, longitude);
	}

	handleLocationError(error) {
		this.setLoading(false);

		switch (error.code) {
			case error.PERMISSION_DENIED:
				this.showPermissionDenied();
				break;
			case error.POSITION_UNAVAILABLE:
				this.showError("Location unavailable");
				break;
			case error.TIMEOUT:
				this.showError("Location request timed out");
				break;
			default:
				this.showError("Unable to get location");
		}
	}

	getPincodeFromCoordinates(latitude, longitude) {
		const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`;

		fetch(url, {
			headers: {
				Accept: "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				const pincode = this.normalizePincode(data.address?.postcode);
				if (pincode) {
					this.cachePincode(pincode);
					this.displayPincode(pincode);
				} else {
					this.showError("Pincode not found");
				}
			})
			.catch((error) => {
				console.error("Reverse geocoding error:", error);
				this.showError("Could not fetch pincode");
			})
			.finally(() => {
				this.setLoading(false);
			});
	}

	displayPincode(pincode) {
		this.pincodeElements.forEach((el) => {
			el.textContent = pincode;
		});

		this.detectors.forEach((detector) => {
			detector.classList.remove("error", "permission-denied", "loading");
			detector.classList.add("success");
		});

		this.broadcastPincodeState(pincode, "success");
		this.setLoading(false);
	}

	showError(message) {
		const currentPincode = this.getCachedPincode() || "110014";
		this.pincodeElements.forEach((el) => {
			el.textContent = currentPincode;
		});

		this.detectors.forEach((detector) => {
			detector.classList.remove("loading");
		});

		this.broadcastPincodeState(currentPincode, "success");
	}

	showPermissionDenied() {
		const currentPincode = this.getCachedPincode() || "110014";
		this.pincodeElements.forEach((el) => {
			el.textContent = currentPincode;
		});

		this.detectors.forEach((detector) => {
			detector.classList.remove("loading");
		});

		this.broadcastPincodeState(currentPincode, "success");
	}

	setLoading(isLoading) {
		if (isLoading) {
			this.detectors.forEach((detector) => detector.classList.add("loading"));
			this.pincodeElements.forEach((el) => {
				el.textContent = "Getting pincode...";
			});
		} else {
			this.detectors.forEach((detector) =>
				detector.classList.remove("loading"),
			);
		}
	}

	setDefaultText() {
		this.pincodeElements.forEach((el) => {
			el.textContent = "Select your pincode";
		});
	}

	cachePincode(pincode) {
		const now = Date.now();
		try {
			localStorage.setItem(this.storageKey, pincode);
			localStorage.setItem(
				this.storageExpiryKey,
				String(now + this.cacheExpiry),
			);
		} catch (error) {
			console.warn("Could not cache pincode:", error);
		}
	}

	getCachedPincode() {
		try {
			const pincode = localStorage.getItem(this.storageKey);
			const expiry = localStorage.getItem(this.storageExpiryKey);

			if (!pincode || !expiry) {
				return null;
			}

			if (Date.now() > Number.parseInt(expiry, 10)) {
				localStorage.removeItem(this.storageKey);
				localStorage.removeItem(this.storageExpiryKey);
				return null;
			}

			return this.normalizePincode(pincode);
		} catch (error) {
			return null;
		}
	}

	normalizePincode(pincode) {
		if (!pincode) {
			return null;
		}

		const digits = String(pincode).replace(/\D/g, "");
		return digits.length >= 6 ? digits.slice(0, 6) : null;
	}

	isDelhiPincode(pincode) {
		return this.delhiPincodes.includes(pincode);
	}

	broadcastPincodeState(pincode, status, message = null) {
		window.dispatchEvent(
			new CustomEvent("kk:pincode:updated", {
				detail: {
					pincode,
					status,
					message,
					isDelhi: Boolean(pincode && this.isDelhiPincode(pincode)),
				},
			}),
		);
	}
}

window.KKPinCodeHelper = {
	isDelhiPincode(pincode) {
		if (!pincode) {
			return false;
		}

		const digits = String(pincode).replace(/\D/g, "");
		const normalized = digits.length >= 6 ? digits.slice(0, 6) : null;
		if (!normalized) {
			return false;
		}

		return [
			"110001", "110002", "110003", "110004", "110005", "110006", "110007", "110008", "110009", "110010",
			"110011", "110012", "110013", "110014", "110015", "110016", "110017", "110018", "110019", "110020",
			"110021", "110022", "110023", "110024", "110025", "110026", "110027", "110028", "110029", "110030",
			"110031", "110032", "110033", "110034", "110035", "110036", "110037", "110038", "110039", "110040",
			"110041", "110042", "110043", "110044", "110045", "110046", "110047", "110048", "110049", "110051",
			"110052", "110053", "110054", "110055", "110056", "110057", "110058", "110059", "110060", "110061",
			"110062", "110063", "110064", "110065", "110066", "110067", "110068", "110070", "110071", "110072",
			"110073", "110074", "110075", "110076", "110077", "110078", "110081", "110082", "110083", "110084",
			"110085", "110086", "110087", "110088", "110089", "110091", "110092", "110093", "110094", "110095",
			"110096", "110097", "121001", "121002", "121003", "121004", "121005", "121006", "121007", "121008",
			"121009", "121012", "121013", "121101", "121102", "121103", "121106", "121107", "122001", "122002",
			"122003", "122004", "122005", "122006", "122008", "122009", "122010", "122011", "122015", "122016",
			"122017", "122018", "122022", "122051", "122052", "122101", "122102", "122103", "122105", "122107",
			"122108", "122413", "122502", "122503", "122504", "122505", "122506", "122508", "123001", "123021",
			"123101", "123106", "123110", "123401", "123501", "124001", "124102", "124103", "124104", "124108",
			"124109", "124401", "124501", "124507", "126101", "126102", "126113", "127021", "127306", "127308",
			"131001", "131021", "131023", "131024", "131027", "131028", "131039", "131101", "131103", "131301",
			"131302", "131304", "131306", "131402", "132001", "132101", "132102", "132103", "132104", "132105",
			"132107", "132108", "132113", "201001", "201002", "201003", "201004", "201005", "201006", "201007",
			"201008", "201009", "201010", "201011", "201012", "201013", "201014", "201015", "201016", "201017",
			"201102", "201201", "201204", "201206", "201301", "201303", "201304", "201305", "201306", "201307",
			"201308", "201309", "201310", "201312", "201313", "201314", "201315", "201318", "203001", "203002",
			"203129", "203131", "203135", "203150", "203201", "203202", "203203", "203205", "203207", "203401",
			"203403", "203408", "245101", "245201", "245205", "245301", "245304", "247774", "250001", "250002",
			"250003", "250004", "250005", "250103", "250110", "250221", "250341", "250401", "250501", "250601",
			"250606", "250609", "250611", "250622", "251001", "251002",
		].includes(normalized);
	},
};

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", () => {
		new PincodeDetector();
	});
} else {
	new PincodeDetector();
}
